export const PENDING_PATIENT_RECEIVED = 'PENDING_PATIENT_RECEIVED';
export const PATIENT_LIST_RECEIVED = 'PATIENT_LIST_RECEIVED';
export const PATIENT_NOTE_RECEIVED= 'PATIENT_NOTE_RECEIVED';
export const CREATE_PRESCRIPTION_PATIENT_LIST_RECEIVED='CREATE_PRESCRIPTION_PATIENT_LIST_RECEIVED';
export const SELECTED_PATIENT_NAME_ADDED='SELECTED_PATIENT_NAME_ADDED';